import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import "../controllers"

// console.log('Vite ⚡️ Rails')
console.log('2026.03.20. v22.4')

// ---- Materialize typing + window globals ----
declare global {
    interface Window {
        Turbo: typeof Turbo
        M?: any
    }
}
window.Turbo = Turbo

function initMaterialize() {
    const M = window.M
    if (!M) return

    // Cleanup existing sidenavs to avoid stale listeners on body and duplicate overlays
    if (M.Sidenav && M.Sidenav._sidenavs) {
        // Create a copy of the array because destroy() modifies it
        const instances = [...M.Sidenav._sidenavs]
        instances.forEach(ins => {
            if (ins && typeof ins.destroy === 'function') {
                ins.destroy()
            }
        })
    }

    // Init modals
    if (M.Modal) {
        const modals = document.querySelectorAll(".modal")
        modals.forEach(el => {
            if (!M.Modal.getInstance(el)) {
                M.Modal.init(el)
            }
        })
    }

    // Init carousels (only if not already initialized by inline scripts)
    if (M.Carousel) {
        const carousels = document.querySelectorAll(".carousel")
        carousels.forEach(el => {
            if (!M.Carousel.getInstance(el)) {
                M.Carousel.init(el, {
                    fullWidth: true,
                    indicators: false
                })
            }
        })
    }

    // Init sidenavs
    if (M.Sidenav) {
        const sidenavs = document.querySelectorAll(".sidenav")
        sidenavs.forEach(el => {
            M.Sidenav.init(el)
        })
    }

    // Init dropdowns
    if (M.Dropdown) {
        const dropdowns = document.querySelectorAll(".dropdown-trigger")
        dropdowns.forEach(el => {
            if (!M.Dropdown.getInstance(el)) {
                M.Dropdown.init(el)
            }
        })
    }
}

function openModalFromQueryParam() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("open_modal") !== "1") return

    const M = window.M
    const modalEl = document.querySelector("#modal1")
    if (!M || !M.Modal || !modalEl) return

    const inst = M.Modal.getInstance(modalEl) || M.Modal.init(modalEl)
    inst.open()

    // Optional: clean the URL so refresh doesn't re-open
    params.delete("open_modal")
    const newQuery = params.toString()
    const newUrl = window.location.pathname + (newQuery ? `?${newQuery}` : "") + window.location.hash
    window.history.replaceState({}, "", newUrl)
}

// Turbo fires reliably on navigations; render covers cache restores too
document.addEventListener("turbo:load", () => {
    initMaterialize()
    openModalFromQueryParam()
})

document.addEventListener("turbo:render", () => {
    initMaterialize()
})

document.addEventListener("click", (e) => {
    const a = (e.target as HTMLElement).closest?.("a.modal-trigger") as HTMLAnchorElement | null
    if (!a) return

    const href = a.getAttribute("href") || ""
    if (!href.startsWith("#")) return

    const target = document.querySelector(href)
    if (!target) {
        e.preventDefault()
        e.stopPropagation() // Prevent Materialize from trying to handle this and crashing
        console.warn("Modal trigger target not found:", href, "trigger:", a)
    }
}, true) // Use capture phase to intercept before Materialize's global listener

